import React from 'react';
import {motion} from 'framer-motion';
const ProgrammingLanguage = (props) => {
return ( 
        <motion.div
     whileTap={{scale:0.5,}}

        id={props.id}>
           <hr />
            <h1>{props.languageName}</h1>
            <img style={{width:'20%',height:'20%'}} src={props.src} />
            <p>{props.description}</p>

            <div>
<br />
<br />
            </div>
        </motion.div>
     );
}
 
export default ProgrammingLanguage;